// z-indices to layer multiple canvas correctly
export const ImageCanvasZIndex = 98;
export const DisabledMaskHostZIndex = 99;
export const SvgHostZIndex = 100;
export const EnabledMaskHostZIndex = 101;

export const KonvaContainerId = "konvaContainer";